import React, { useRef,useMemo } from 'react';
import { motion, useInView } from 'framer-motion';
import { useTranslation } from 'react-i18next'; 
import constructionIcon from '../images/construction_icon.png';
import electriciteIcon from '../images/electricité_icon.png';
import informatiqueIcon from '../images/informatique_icon.png';
import marketingIcon from '../images/marketing_icon.png';
import './Departments.css';

const Departments = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });


  const departments = useMemo(() => [
    {
      icon: constructionIcon,
      title: t('Sous_Services_BTP'),
      description: t('msg_Departement_construction'),
      link: '/genie-civil',
      color: '#0066cc',
      hoverColor: '#004d99',
    },
    {
      icon: electriciteIcon,
      title: t('titre_Departement_electricite'),
      description: t('msg_Departement_electricite'),
      link: '/genie-electrique',
      color: '#c8a02b',
      hoverColor: '#a8851f',
    },
    {
      icon: informatiqueIcon,
      title: t('titre_Departement_informatique'),
      description: t('msg_Departement_informatique'),
      link: '/genie-informatique',
      color: '#107a3e',
      hoverColor: '#0c5f30',
    },
    {
      icon: marketingIcon,
      title: t('marketing_card_titre_Notre_expertise'),
      description: t('msg_Departement_marketing'),
      link: '/communication',
      color: '#6b3fa0',
      hoverColor: '#553082',
    },
  ], [t]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const buttonVariants = {
    hover: {
      scale: 1.02,
      boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
      transition: { duration: 0.2 },
    },
    tap: { scale: 0.97 },
  };

  return (
    <section className="departments-section" id="solutech_features_area" ref={ref}>
      <div className="container">
        <div className="section-header">
          <h2>{t('titre_Notre_expertise')}</h2>
        
        </div>

        <motion.div
          className="departments-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          {departments.map((dept, index) => (
            <motion.div
              key={index}
              className="department-card"
              variants={cardVariants}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.2 }}
            >
              <div className="department-content">
                <div className="department-icon" style={{ borderColor: dept.color }}>
                  <img src={dept.icon} alt={dept.title} />
                </div>
                <h3 style={{ color: dept.color }}>{dept.title}</h3>
                <p>{dept.description}</p>
                <motion.a
                  href={dept.link}
                  className="btn-department"
                  variants={buttonVariants}
                  whileHover="hover"
                  whileTap="tap"
                  style={{
                    borderColor: dept.color,
                    color: dept.color,
                  }}
                >
                  {t('btn_Decouvrir')}
                </motion.a>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Departments;